// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2F71C","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__hEAbl"};